import {
  CustomHomepageGrid,
  HomePageStarredEntities,
  HomePageRecentlyVisited,
  HomePageTopVisited,
  HomePageRandomJoke,
  WelcomeTitle,
} from '@backstage/plugin-home';
import { JiraUserIssuesViewCard } from '@axis-backstage/plugin-jira-dashboard';
import {
  Content,
  Header,
  Page,
} from '@backstage/core-components';

const defaultConfig = [
  { component: 'HomePageRecentlyVisited', x: 0, y: 0, width: 6, height: 4 },
  { component: 'JiraUserIssuesViewCard', x: 6, y: 0, width: 6, height: 8 },
  { component: 'HomePageTopVisited', x: 0, y: 4, width: 6, height: 4 },
  { component: 'HomePageStarredEntities', x: 0, y: 8, width: 6, height: 4 },
  { component: 'HomePageRandomJoke', x: 6, y: 8, width: 6, height: 4 },
];

export const HomePage = () => (
  <Page themeId="home">
    <Header
      title={<WelcomeTitle language={['English']} />}
      pageTitleOverride="Home"
    />
    <Content>
      <CustomHomepageGrid config={defaultConfig}>
        <HomePageRecentlyVisited />
        <HomePageTopVisited />
        <JiraUserIssuesViewCard title="Your Open Jira Tickets" />
        <HomePageRandomJoke />
        <HomePageStarredEntities />
      </CustomHomepageGrid>
    </Content>
  </Page>
);
